export const dealMarketingTypes = [
    "Marketing",
    "Cross-Sale",
    "Project Manager",
    "Tender",
    "E-Commerce",
    "Marketing Cross Sale",
    "Re-Seller Partnership",
    "Portfolio Sale",
];
export const dealMarketingTypesOptions = dealMarketingTypes.map((item) => ({ label: item, value: item }));
export const statusOptions = [
    { label: "WON", value: "Won", activeVariant: "success" },
    { label: "Lost", value: "Lost", activeVariant: "neutral" },
    { label: "Cancelled", value: "Cancelled", activeVariant: "neutral" },
];
export const dealChannelTypes = [
    "Bayt",
    "Certifind",
    "Edarabia",
    "Eventbrite",
    "E-Shot",
    "Facebook Inquiry",
    "Find Courses",
    "Gulf Talent",
    "Key Stone Academic Solutions",
    "Laimoon",
    "Linkedin",
    "Nigerian Training and Seminars",
    "Partner Academies",
    "Phone Inquiries",
    "Social Media",
    "Speedy Course",
    "Web Inquiry",
    "Website's Chat Box",
    "WhatsApp",
    "Adwords Istizada",
    "Ta3leem",
    "Instagram",
    "Courseseekers",
    "E-Commerce",
    "Web Inquiry - Program Enrollment",
];
export const campaignTypes = [
    "Self-Paced",
    "EdTech",
    "Mentoring",
    "Departmental",
    "Private",
    "Public",
    "In-house",
    "Consulting",
    "Online",
    "CH",
    "Business Trip",
    "LVT Public",
    "LVT In-house",
    "Webinar",
    "Franchise",
    "L&D Broker",
    "E-Learning",
    "Coaching",
    "Classroom/Online",
    "Public-ExEd",
    "Learning Journey",
    "Other",
];

export const publicTypes = [
    "Self-Paced",
    "LVT Public",
    "Public",
    "Mentoring",
    "Departmental",
    "Private",
    "Online",
    "CH",
    "Business Trip",
    "Webinar",
    "Franchise",
    "Classroom",
    "Other",
    "L&D Broker",
    "Public-ExEd",
    "Classroom/Online",
];

export const inHouseTypes = ["In-house", "LVT In-house", "Learning Journey"];

export const inquiryTypes = ["E-Learning", "EdTech", "Consulting", "Coaching"];

export const campaignTypesOptions = campaignTypes.map((item) => ({ label: item, value: item }));
export const dealChannelTypesOptions = dealChannelTypes.map((item) => ({ label: item, value: item }));

export const colorArray = [
    "#081B26",
    "#384D56",
    "#6F8086",
    "#A7B2B7",
    "#286A99",
    "#3C9DCB",
    "#66B5D8",
    "#99CDE5",
    "#276A54",
    "#389D87",
    "#65B5A5",
    "#99CEC3",
    "#A24C28",
    "#D57F5A",
    "#DF9F84",
    "#EABFAD",
    "#B43636",
    "#E76969",
    "#ED8E8E",
    "#F3B4B4",
    "#7018AD",
    "#A33FE0",
    "#BA6EE8",
    "#D19EEF",
];
export const tagOptions = [
    {
        label: "Call",
        value: "Call",
    },
    {
        label: "Call Back",
        value: "Call Back",
    },
    {
        label: "Follow Up",
        value: "Follow Up",
    },
    {
        label: "Meeting",
        value: "Meeting",
    },
    {
        label: "Customer Chat",
        value: "Customer Chat",
    },
    {
        label: "Other",
        value: "Other",
    },
];

export const POPUP_CONTENTS = {
    ABOUT: "About",
    COURSES: "Campaigns",
    DEALS: "Deals",
    NEW_DEAL: "New Deal",
    NOTES: "Notes",
    NEW_TASK: "New Task",
    EDIT_TASK: "Edit Task",
    FEED: "Feed",
    TRANSFER_DEAL: "Transfer Deal",
    NOTES_ATTACHMENT: "NotesAttachment",
    PROFILE_TASKS: "Profile Tasks",
};

export const INHOUSE_DEAL_OBJECT = {
    amount: "",
    partner: "",
    partnerUserId: "",
    partnerName: "",
    vatIncluded: "",
    paidDeal: "",
};

export const TOGGLE_OPTIONS = [
    { label: "Yes", value: "Yes", activeVariant: "success" },
    { label: "No", value: "No", activeVariant: "neutral" },
];

export const DEAL_WON = "Won";
export const DEAL_LOST = "Lost";
export const DEAL_CANCELLED = "Cancelled";

export const DEAL_STATUS_OPTIONS = [
    { label: "WON", value: DEAL_WON, activeVariant: "success" },
    { label: "Lost", value: DEAL_LOST, activeVariant: "neutral" },
    { label: "Cancelled", value: DEAL_CANCELLED, activeVariant: "neutral" },
];
